let scroll_to_element_by_id = (id) => {
    const element = document.getElementById(id);

    element.scrollTop = element.scrollHeight;
}

export default scroll_to_element_by_id;
